import { Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { Layout } from '@/components/layout/Layout'
import { Login } from '@/pages/Login'
import { Overview } from '@/pages/Overview'
import { Accounts } from '@/pages/Accounts'
import { AccountDetail } from '@/pages/AccountDetail'
import { AuditLog } from '@/pages/AuditLog'
import { Analytics } from '@/pages/Analytics'
import { AbuseQueue } from '@/pages/AbuseQueue'
import { Domains } from '@/pages/Domains'
import { Security } from '@/pages/Security'
import { Settings } from '@/pages/Settings'
import { Waitlist } from '@/pages/Waitlist'
import { StatusAdmin } from '@/pages/StatusAdmin'
import { BroadcastAdmin } from '@/pages/BroadcastAdmin'
import { SuperadminManagement } from '@/pages/SuperadminManagement'
import { getAdminRole, canAccess, type AdminRole } from '@/lib/auth'
import { ConsentBanner } from '@/components/ConsentBanner'

// CHECKPOINT: PRD-10 FR-10.12.1 — Role-based route guard for elevated screens
function RequireRole({ minRole, children }: { minRole: AdminRole; children: JSX.Element }) {
  const role = getAdminRole()
  return canAccess(role, minRole) ? children : <Navigate to="/" replace />
}

// CHECKPOINT: PRD-10 FR-10.12.1 — Global auth guard for all admin routes except /login
function RequireAuth() {
  const token = localStorage.getItem('admin_token')
  return token ? <Outlet /> : <Navigate to="/login" replace />
}

function App() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
      {/* PRD-10 FR-10.12.1: /admin route alias inside the admin SPA */}
      <Route path="/admin" element={<Navigate to="/" replace />} />
      <Route element={<RequireAuth />}>
        <Route element={<Layout />}>
          <Route path="/" element={<Overview />} />
          <Route path="/accounts" element={<Accounts />} />
          <Route path="/accounts/:id" element={<AccountDetail />} />
          <Route path="/waitlist" element={<Waitlist />} />
          <Route path="/audit-log" element={<AuditLog />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/abuse-queue" element={<AbuseQueue />} />
          <Route path="/domains" element={<Domains />} />
          <Route path="/status" element={<StatusAdmin />} />
          <Route path="/broadcasts" element={<RequireRole minRole="founder"><BroadcastAdmin /></RequireRole>} />
          <Route path="/superadmins" element={<RequireRole minRole="founder"><SuperadminManagement /></RequireRole>} />
          <Route path="/security" element={<Security />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
      </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ConsentBanner />
    </>
  )
}

export default App
